var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/added-green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/added-green",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "on"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "space",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.4612364,13.0381091 L13.3850182,13.0381091 C13.1938909,13.0381091 13.0381091,13.1925818 13.0381091,13.3837091 L13.0381091,15.4612364 C13.0381091,16.0346182 12.5733818,16.4993455 12,16.4993455 C11.4266182,16.4993455 10.9605818,16.0346182 10.9605818,15.4612364 L10.9605818,15.2648727 L10.9605818,13.3837091 C10.9605818,13.1925818 10.8061091,13.0381091 10.6149818,13.0381091 L8.93018182,13.0381091 L8.53876364,13.0381091 C7.96407273,13.0381091 7.49934545,12.5733818 7.49934545,12 C7.49934545,11.4266182 7.96407273,10.9605818 8.53876364,10.9605818 L8.93018182,10.9605818 L10.6149818,10.9605818 C10.8061091,10.9605818 10.9605818,10.8061091 10.9605818,10.6149818 L10.9605818,8.53745455 C10.9605818,8.31752727 11.0443636,8.12509091 11.1621818,7.95752727 C11.3493818,7.68785455 11.6465455,7.49934545 12,7.49934545 C12.5733818,7.49934545 13.0381091,7.96407273 13.0381091,8.53745455 L13.0381091,10.6149818 C13.0381091,10.8061091 13.1938909,10.9605818 13.3850182,10.9605818 L15.4612364,10.9605818 C16.0346182,10.9605818 16.4993455,11.4266182 16.4993455,12 C16.4993455,12.5733818 16.0346182,13.0381091 15.4612364,13.0381091 M12,3 C11.7172364,3 11.4384,3.01570909 11.1621818,3.04189091 C10.3845818,3.11389091 9.6384,3.29061818 8.93018182,3.5472 C5.47418182,4.80392727 3,8.10807273 3,12 C3,12.8142545 3.11781818,13.5984 3.32072727,14.3485091 C3.53541818,15.1418182 3.85352727,15.8906182 4.26327273,16.5818182 C5.83156364,19.2235636 8.70501818,21 12,21 C16.9706182,21 21,16.9693091 21,12 C20.9934545,7.032 16.968,3.00523636 12,3",
    id: "Fill-6",
    fill: "#72BF44"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.ca688203beab28abb21104776c24bd8d.svg";
export { ForwardRef as ReactComponent };